/**
 * 数据源枚举
 * 1 表示静态数据源
 * 2 表示测点数据源
 * 3 表示Api数据源
 */
export const enum DataSource {
    Static = 1,
    Point,
}

/**
 * valueType取值类型
 * 1实时值 
 * 2历史值 
 */
export const enum ValueType {
    Real = 1,
    History,
}

/**
 * childType
 * 1工程值
 * 2统计值
 */
export const enum ChildType {
    EngineValue = 1,
    Statistics,
}

/**
 * 申明返回值为布尔的方法
 */
export type booleanType = () => boolean;